import { connect } from 'react-redux'

import {
  addAmount,
  sendPromo,
  resetPromo,
  personalInfoChange,
  changeDeliveryType,
  cartPageLeaving,
} from 'actions'
import { REGION_JP } from 'constants/regions'
import {
  CART,
  TERMS_AND_CONDITIONS,
  PRIVACY_POLICY,
  ESSENTIAL_POINTS,
} from 'constants/textBunchesNames'
import withLocalization from 'containers/withLocalization'
import { getIsCartInitializingOrUpdating } from 'selectors'

import Component from './Cart'

const extraTexts =
  process.env.region === REGION_JP
    ? {
        [TERMS_AND_CONDITIONS]: TERMS_AND_CONDITIONS,
        [PRIVACY_POLICY]: PRIVACY_POLICY,
        [ESSENTIAL_POINTS]: ESSENTIAL_POINTS,
      }
    : {}

function mapStateToProps(state) {
  return {
    cart: state.cart,
    isCartInitOrUpdate: getIsCartInitializingOrUpdating(state),
  }
}

const mapDispatchToProps = {
  addAmount,
  sendPromo,
  resetPromo,
  personalInfoChange,
  changeDeliveryType,
  cartPageLeaving,
}

const LocalizedComponent = withLocalization(Component, CART, extraTexts)

export default connect(mapStateToProps, mapDispatchToProps)(LocalizedComponent)
